export default function CandleVisual({
  lit,
  big = false,
  size = "md",
  testId = "candle-flame",
  onClick,
  buttonTestId = "candle-visual-button",
  rose = false,
}) {
  const dims =
    size === "xl" ? "h-32 w-20" : size === "lg" ? "h-16 w-10" : "h-12 w-8";
  const flameClass = `flame${size === "xl" ? " flame-xl" : ""}${big ? " flame-big" : ""}`;
  const candle = (
    <div className="relative flex items-end">
      {rose && (
        <svg
          viewBox="0 0 40 64"
          className="-mr-2 h-16 w-10 -rotate-12"
          aria-hidden="true"
          data-testid="candle-rose"
        >
          <path
            d="M22 62 C 20 48, 18 40, 17 28"
            stroke="#4a7c59"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
          <path d="M19 44 C 12 42, 9 37, 10 33 C 16 34, 19 38, 19 44 Z" fill="#5d8f6a" />
          <path d="M18 36 C 24 35, 28 31, 27 26 C 21 27, 18 31, 18 36 Z" fill="#4a7c59" />
          <circle cx="16" cy="18" r="11" fill="#C85A32" />
          <circle cx="16" cy="18" r="7" fill="#D97A56" />
          <circle cx="16" cy="18" r="3.5" fill="#EBA580" />
        </svg>
      )}
      <div
        className={`relative ${dims} rounded-t-md bg-gradient-to-b from-[#F4EFEA] to-[#E3D7C3] shadow-inner`}
      >
        {lit && <div className={flameClass} data-testid={testId} />}
        <div className="absolute left-1/2 top-0 h-2 w-0.5 -translate-x-1/2 bg-stone-700" />
      </div>
    </div>
  );
  if (!onClick) return candle;
  return (
    <button
      type="button"
      data-testid={buttonTestId}
      onClick={onClick}
      className="cursor-pointer transition-transform duration-300 hover:scale-105 active:scale-95"
      aria-label="Raviver la flamme de la bougie"
    >
      {candle}
    </button>
  );
}
